import React, { useCallback, useState } from "react";
import { DatePicker, Form, Input, Select } from "antd";
import CustomButton from "components/Common/buttons/CustomButton";
import { filterOptions } from "./variables";
import useStoreFilters from "customHooks/useStoreFilters";
import { FILTER_PAGE } from "utils/constants";
import { inputPatternTitle, inputTextPattern } from "components/Common/inputs/variables";
import { dateFormat } from "pages/TAM/TAMRequests/constants";
import { getEndOfTheDay, getStartOfTheDay } from "components/Common/formatter";
import { makeStyles } from "@material-ui/core/styles";

const { Option } = Select;
const { RangePicker } = DatePicker;

const useStyles = makeStyles({
  root: { width: "250px!important" },
});

const AwaitingPreparationFilter = ({ handleFilter }) => {
  const classes = useStyles();
  const [form] = Form.useForm();
  const { getFilters } = useStoreFilters(FILTER_PAGE.AWAITING_PREPARATION);
  const [selectedType, setSelectedType] = useState(null);

  const onSearch = useCallback(values => {
    const { pageSize } = getFilters();
    if (values?.type === "date") {
      const filter = { pageSize };
      filter.minCreatedAt = getStartOfTheDay(values?.date[0]);
      filter.maxCreatedAt = getEndOfTheDay(values?.date[1]);
      handleFilter(filter);
    } else {
      !(values.value && !values.type) &&
        handleFilter(values.type ? { [values.type]: values.value?.trim(), pageSize } : {});
    }
  }, []);

  const onTypeChange = useCallback(
    type => {
      setSelectedType(type);
      form.setFieldValue("value", null);
    },
    [form]
  );

  return (
    <div className="custom-filter">
      <Form form={form} name="horizontal_login" layout="inline" onFinish={onSearch}>
        <Form.Item name="type">
          <Select showSearch onChange={onTypeChange} placeholder={"Select type"} allowClear>
            {filterOptions.map(item => (
              <Option key={item.value} value={item.value}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        {selectedType && selectedType !== "date" && (
          <>
            <div className="filter-divider" />
            <Form.Item name="value" rules={[{ required: true, message: "Please enter value" }]}>
              <Input placeholder="Enter value" allowClear pattern={inputTextPattern} title={inputPatternTitle} />
            </Form.Item>
          </>
        )}
        {selectedType === "date" && (
          <Form.Item
            name="date"
            rules={[{ required: true, message: "Please select date range" }]}
            className={classes.root}
          >
            <RangePicker inputReadOnly={true} format={dateFormat} size={"default"} />
          </Form.Item>
        )}
        <CustomButton size="small" type="primary" htmlType="submit" text="Search" />
      </Form>
    </div>
  );
};

export default AwaitingPreparationFilter;
